module.exports = __webpack_public_path__ + "static/media/career-videos.4186e73a.jpg";